import { useEffect, useCallback } from 'react'
import { useReduxState } from '@/hooks/reduxState'
import { createSelector } from 'reselect'
import { getStore } from '@/store'
import { actionCreators } from '@/store/backgroundJobs'
import { useCommonHub } from '@/hooks/useCommonHub'
import { isAnonymousLocation } from '@/components/auth/isAnonymousLocation'
import { useLocation } from 'react-router-dom'

const userSelector = state => state.identity && state.identity.user
const signedInSelector = createSelector(userSelector, user => !!(user && !user.expired))

const useInitializer = (options) => {
  const { onLoad } = options || {}
  const { signedIn } = useReduxState(useCallback(state => ({
    signedIn: signedInSelector(state)
  }), []))
  useCommonHub()
  useEffect(() => {
    if (signedIn) {
      getStore().dispatch(actionCreators.loadJobsProgress())
      if (typeof onLoad === 'function') onLoad()
    }
  }, [onLoad, signedIn])
  const location = useLocation()
  return {
    isAnonymousPath: isAnonymousLocation(location),
    signedIn
  }
}

export {
  useInitializer
}



// WEBPACK FOOTER //
// ./src/hooks/useInitializer.js